import api from "@/api/viktor"

//-- Global assessments
export async function getAssessment(test: string) {
  const response = await api({
    method: "GET",
    url: `/me/assessment/${test}?is_active=1`,
  })
  return response
}

export async function postAssessment(test: string, data: any) {
  const response = await api({
    method: "POST",
    url: `/me/assessment/${test}`,
    data,
  })
  return response
}

export async function patchAssessment(test: string, data: any) {
  const response = await api({
    method: "PATCH",
    url: `/me/assessment/${test}`,
    data,
  })
  return response
}

export async function deleteAssessment(test: string) {
  const response = await api({
    method: "DELETE",
    url: `/me/assessment/${test}`,
  })
  return response
}

//-- Swipe
export async function getSwipeActive() {
  return await api({
    method: "GET",
    url: "/me/swipe?is_active=1",
  })
}

export async function patchSwipe(data: any) {
  return await api({
    url: "/me/swipe",
    method: "patch",
    data,
  })
}

export async function patchGlobalUserData(id: string, data: any) {
  return await api({
    url: `/user/${id}`,
    method: "patch",
    data,
  })
}

export async function postSwipe(data: any) {
  return await api({
    url: "/me/swipe",
    method: "post",
    data,
  })
}

export async function deleteSwipe() {
  localStorage.removeItem("swipe-locale")
  return await api({
    url: "/me/swipe",
    method: "delete",
  })
}

//-- Brain
// Pour récupérer les instructions de la prochaine question à afficher sur Brain (status: inprogress)
export async function getBrainNextItem() {
  const response = await api({
    method: "GET",
    url: `/me/brain/next-items`,
  })
  return response
}

//-- Voice
export async function getVoiceQuestions(user_uuid: string, voice_uuid: string) {
  const response = await api({
    method: "GET",
    url: `/user/${user_uuid}/voice/${voice_uuid}/questions`,
  })
  return response
}

export async function getVoiceNextQuestion(
  user_uuid: string,
  voice_uuid: string
) {
  const response = await api({
    method: "GET",
    url: `/user/${user_uuid}/voice/${voice_uuid}/question/next`,
  })
  return response
}

export async function postVoiceAudioQuestion(
  user_uuid: string,
  voice_uuid: string,
  question_uuid: string,
  audio: Blob,
  suspiciousActivity?: Record<string, unknown>
) {
  const formData = new FormData()
  formData.append("file", audio, "audio.mp3")

  if (suspiciousActivity) {
    formData.append("suspicious_data", JSON.stringify(suspiciousActivity))
  }

  const response = await api({
    method: "POST",
    url: `/user/${user_uuid}/voice_user/${voice_uuid}/question/${question_uuid}/mp3`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return response
}

export async function postVoiceAudio(
  user_uuid: string,
  voice_uuid: string,
  audio: Blob,
  audioType: string
) {
  const formData = new FormData()
  formData.append("file", audio, "audio.mp3")
  formData.append("audio_type", audioType)

  const response = await api({
    method: "POST",
    url: `/user/${user_uuid}/voice_user/${voice_uuid}/mp3`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
  return response
}

export async function skipVoiceQuestion(
  user_uuid: string,
  voice_uuid: string,
  question_uuid: string
) {
  const response = await api({
    method: "POST",
    url: `/user/${user_uuid}/voice_user/${voice_uuid}/question/${question_uuid}/skip`,
  })
  return response
}

export async function restartVoice(user_uuid: string, pm_uuid: string) {
  const response = await api({
    method: "POST",
    url: `/user/${user_uuid}/pm/${pm_uuid}/voice/retake`,
  })
  return response
}
export async function restartScreening(user_uuid: string, pm_uuid: string) {
  const response = await api({
    method: "POST",
    url: `/user/${user_uuid}/pm/${pm_uuid}/screening/retake`,
  })
  return response
}

export async function generateScreeningToken(
  pm_uuid: string,
  user_uuid: string,
  locale_id: string | number
) {
  const response = await api({
    method: "GET",
    url: `/pm/${pm_uuid}/user/${user_uuid}/token?locale_id=${locale_id}`,
  })
  return response
}

export async function postBookMeeting(pm_uuid: string, user_uuid: string) {
  const response = await api({
    method: "POST",
    url: `/pm/${pm_uuid}/user/${user_uuid}/meeting`,
  })
  return response
}
